import { createSlice } from "@reduxjs/toolkit";
export const resourceTreeSlice = createSlice({
    name: 'resourceTree',
    initialState: {
        isVisible: true,
        selectedResourceID: null,
    },
    reducers: {
        toggleVisible: (state) => {
            state.isVisible = !state.isVisible;
        },
        setSelectedResourceID: (state, action) => {
            state.selectedResourceID = action.payload;
        }
    },
    selectors: {
        isVisible: (state) => state.isVisible,
        getSelectedResourceID: (state) => state.selectedResourceID,
    },
});
//# sourceMappingURL=resourceTreeSlice.js.map